module.exports = __webpack_public_path__ + "images/a56d143455e3ec858903dfbb5eb86f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/logo.png
// module id = 1922
// module chunks = 0